// extracted by mini-css-extract-plugin
export default {"loading":"ProductList_loading__9o7l5","placeHolderShimmer":"ProductList_placeHolderShimmer__voedW"};